/**
 * ============================================================================
 * PAGE FOOTER — support/ticket line shown at the bottom of every page.
 * ============================================================================
 *
 * Mounted once in App.tsx (below the routed content), NOT per page.
 * The ticket link and CTI are the same ones the legacy Project Portal uses
 * (AGI-DS / CollectionTracking / General → ADS-WorkforceManagement group).
 */

import React from 'react';
import './PageFooter.scss';

const CUT_TICKET_URL =
  'https://t.corp.amazon.com/create/options?category=AGI-DS&type=CollectionTracking&item=General&group=ADS-WorkforceManagement';

export const PageFooter: React.FC = () => (
  <footer className="page-footer">
    Having issues?{' '}
    <a href={CUT_TICKET_URL} target="_blank" rel="noopener noreferrer">
      Cut a ticket
    </a>{' '}
    with <strong>AGI-DS / CollectionTracking / General</strong>
  </footer>
);
